module.exports = __webpack_public_path__ + "static/media/lucesEmergencia.bb37733f.png";